import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { BackText } from '../atoms';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 100vh;
  padding: 30px 20px;
`;

const NotFoundPage = () => (
  <Wrapper>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="300"
        height="240"
        viewBox="0 0 300 240"
      >
        <defs>
          <rect id="404-b" width="220" height="220" x="12" y="0" rx="4" />
          <filter
            id="404-a"
            width="172.7%"
            height="173.2%"
            x="-36.4%"
            y="-18.6%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="40" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
              stdDeviation="20"
            />
            <feColorMatrix
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
              values="0 0 0 0 0.28627451   0 0 0 0 0.31372549   0 0 0 0 0.341176471  0 0 0 0.1 0"
            />
            <feOffset
              dx="10"
              dy="14"
              in="SourceAlpha"
              result="shadowOffsetOuter2"
            />
            <feGaussianBlur
              in="shadowOffsetOuter2"
              result="shadowBlurOuter2"
              stdDeviation="7.5"
            />
            <feColorMatrix
              in="shadowBlurOuter2"
              result="shadowMatrixOuter2"
              values="0 0 0 0 0.129411765   0 0 0 0 0.145098039   0 0 0 0 0.160784314  0 0 0 0.04 0"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="shadowMatrixOuter2" />
            </feMerge>
          </filter>
          <linearGradient
            id="404-c"
            x1="53.974%"
            x2="29.371%"
            y1="140.055%"
            y2="62.482%"
          >
            <stop offset="0%" stop-color="#C4C8DE" stop-opacity="0" />
            <stop offset="100%" stop-color="#ADB5BD" />
          </linearGradient>
          <linearGradient
            id="404-e"
            x1="122.435%"
            x2="50%"
            y1="11.346%"
            y2="84.277%"
          >
            <stop offset="0%" stop-color="#FFF" />
            <stop offset="100%" stop-color="#F8F9FA" />
          </linearGradient>
          <path
            id="404-d"
            d="M19.1673199,0 L212.16732,0 L212.16732,145.065942 L208.19434,138.028294 L204.534587,150.757097 L198.737567,144.52253 L193.727301,147.065942 L178.877866,144.52253 L176.130408,193 L169.772127,193.107022 L165.13821,191.456219 L155.916016,193 L149.551584,190.398314 L139.937597,193 L134.937597,132.990932 L129.609073,193 L121.525769,191.401423 L114.025009,193.773916 L104.188194,191 L89.1051359,193 L84.6583321,189.931094 L79.9133852,193 L69.4395225,193 L69.4395225,60 C66.7674277,98.6538747 62.9138388,122.984186 57.8787558,132.990932 C54.6509881,139.405813 49.4510117,141.146938 46.0483894,142.636451 C41.4892465,144.632237 38.043928,145.065942 26.6845764,145.065942 C13.4597967,145.065942 4.56493794,138.053646 0,124.029054 C5.09668697,120.474843 9.23964607,115.08342 12.4288773,107.854786 C15.6181085,100.626151 17.8642561,84.674556 19.1673199,60 L19.1673199,0 Z"
          />
          <linearGradient
            id="404-g"
            x1="-13.091%"
            x2="93.537%"
            y1="12.097%"
            y2="79.174%"
          >
            <stop offset="0%" stop-color="#F8F9FA" />
            <stop offset="63.355%" stop-color="#E3E7EA" />
            <stop offset="100%" stop-color="#ADB5BD" />
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd" transform="translate(28 1)">
          <use fill="#000" filter="url(#404-a)" xlinkHref="#404-b" />
          <use fill="#FFF" xlinkHref="#404-b" />
          <path
            fill="url(#404-c)"
            d="M29,15 L216,15 C217.104569,15 218,15.8954305 218,17 L218,205 C218,206.104569 217.104569,207 216,207 L29,207 C27.8954305,207 27,206.104569 27,205 L27,17 C27,15.8954305 27.8954305,15 29,15 Z"
            opacity=".487"
          />
          <g transform="translate(7 14)">
            <mask id="404-f" fill="#fff">
              <use xlinkHref="#404-d" />
            </mask>
            <use fill="url(#404-e)" xlinkHref="#404-d" />
            <path
              fill="#ADB5BD"
              fill-rule="nonzero"
              d="M82.6055363,91 L82.6055363,80.7444444 L89,80.7444444 L89,71.9333333 L82.6055363,71.9333333 L82.6055363,39 L70.7612457,39 L47,72.8 L47,80.7444444 L72.432526,80.7444444 L72.432526,91 L82.6055363,91 Z M73,72 L58,72 L73,50 L73,72 Z M115.5,91 C130.377778,91 135,79.4129555 135,63.8906883 C135,48.51417 130.377778,37 115.5,37 C100.622222,37 96,48.51417 96,63.8906883 C96,79.4129555 100.622222,91 115.5,91 Z M115.5,82 C107.100899,82 106.023048,74.0284417 106.000374,64.7022191 L106,64.3908524 C106,55.2952183 107.007576,47 115.5,47 C123.992424,47 125,55.2952183 125,64.3908524 C125,73.8503119 123.992424,82 115.5,82 Z M177.605536,91 L177.605536,80.7444444 L184,80.7444444 L184,71.9333333 L177.605536,71.9333333 L177.605536,39 L165.761246,39 L142,72.8 L142,80.7444444 L167.432526,80.7444444 L167.432526,91 L177.605536,91 Z M168,72 L153,72 L168,50 L168,72 Z"
              mask="url(#404-f)"
            />
          </g>
          <path
            fill="url(#404-g)"
            d="M0.936226628,129.556616 L52.2632466,129.556616 C54.851655,142.531533 59.0606026,148.269028 64.8900893,146.769101 C61.0951001,154.489005 53.1823433,160.496025 36.3532647,160.496025 C19.5241861,160.496025 12.5552933,154.071516 8.39011019,149.578057 C5.61332142,146.582417 3.12869356,139.908603 0.936226628,129.556616 Z"
            opacity=".624"
          />
        </g>
      </svg>

      <h1 className="h3">Oops! That page can't be found...</h1>
      <NavLink to={`/login`}>
        <BackText text="Back to Dashboard" />
      </NavLink>
    </div>
  </Wrapper>
);

export { NotFoundPage };
